/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './implant-group.reducer';

export const ImplantGroupDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const implantGroupEntity = useAppSelector(state => state.implantGroup.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="implantGroupDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.implantGroup.detail.title">ImplantGroup</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.implantGroup.id">Id</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.id}</dd>
          <dt>
            <span id="category">
              <Translate contentKey="tinyMedicRestApp.implantGroup.category">Category</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.category}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tinyMedicRestApp.implantGroup.type">Type</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.type}</dd>
          <dt>
            <span id="addedBy">
              <Translate contentKey="tinyMedicRestApp.implantGroup.addedBy">Added By</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.addedBy}</dd>
          <dt>
            <span id="deviceTypeName">
              <Translate contentKey="tinyMedicRestApp.implantGroup.deviceTypeName">Device Type Name</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.deviceTypeName}</dd>
          <dt>
            <span id="riskClass">
              <Translate contentKey="tinyMedicRestApp.implantGroup.riskClass">Risk Class</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.riskClass}</dd>
          <dt>
            <span id="generalIntendedUse">
              <Translate contentKey="tinyMedicRestApp.implantGroup.generalIntendedUse">General Intended Use</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.generalIntendedUse}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.implantGroup.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.timestampentry}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.implantGroup.active">Active</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.implantGroup.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.implantGroup.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.implantGroup.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{implantGroupEntity.microSec}</dd>
        </dl>
        <Button tag={Link} to="/implant-group" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/implant-group/${implantGroupEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ImplantGroupDetail;
